import React, { useState, useEffect } from "react";
import "./personalDetail.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import Carousels from "../../../components/Slider/index";
import { DatePicker, message } from "antd";
import UseIsMobile from "../../../feature/ismobilescreen";
import { SignUpCarousel, get18YearBackDate } from "../../../utils/index";
import moment from "moment";
import * as dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import AxiosInstance from "../../../AxiosInstance";
import { ADMIN_ROLES } from "../../../constants";

dayjs.extend(customParseFormat);

export default function PersonalDetail() {
  const { width } = UseIsMobile();
  const [isMobScreen, setMobScreen] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const location = useLocation();
  const [isReferralLocked, setIsReferralLocked] = useState(false);

  // Access referralCode from state (if available)
  const referralCode = location.state?.referralCode ?? "";

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
  } = useForm({ mode: "onChange" });

  useEffect(() => {
    if (referralCode && referralCode.trim() !== "") {
      setValue("referralCode", referralCode);
      setIsReferralLocked(true);
    }
    else { setIsReferralLocked(false); }
  }, [referralCode, setValue]);

  useEffect(() => {
    //because user can come back to this route
    const storedData = JSON.parse(localStorage.getItem("data")) || {};
    //storedData.agree = true;
    const nameParts = storedData?.applicantName?.trim( ).split(/\s+/);
    const firstName = nameParts?.[0] || "";
    const lastName = nameParts?.slice(1).join(" ") || "";
    setValue("firstName", firstName);
    setValue("lastName", lastName); 
    setValue("email", storedData?.email || "");
    setValue("dob", new Date(storedData?.dob || "1990-01-01"));
    setValue("referralCode", storedData?.referralCode || referralCode);
    setValue("agree", storedData?.agree || true);

    // Disable the input fields if data exists
    if (storedData) {
      Object.keys(storedData).forEach((field) => {
        const inputElement = document.getElementById(field);
        if (inputElement) {
          inputElement.disabled = true;
        }
      });
    }
  }, [setValue, referralCode]);

  const isEmailValid = (email) => {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
  };

  const checkMailAvailability = async (value) => {
    const storedData = JSON.parse(localStorage.getItem("data")) || {};

    if (ADMIN_ROLES.includes(storedData?.role)) {
      return transferData(value);
    }
    if (isEmailValid(value.email)) {
      AxiosInstance()
        .get(`/user/checkEmail?email=${value.email}`)
        .then(() => {
          transferData(value);
          return true;
        })
        .catch((err) => {
          message.error(err.response.data.message);
          return false;
        });
    }
  };

  const transferData = (value) => {
    delete value.agree;
    console.log(value);
    const nameParts = value.applicantName.trim( ).split(/\s+/);
    const firstName = nameParts[0] || "";
    const lastName = nameParts.slice(1).join(" ") || "";
    console.log(firstName, lastName);
    const apiData = {
      ...value,
      firstName,
      lastName
    };
    delete apiData.applicantName;
    console.log(apiData);
    // return;
    const stored = JSON.parse(localStorage.getItem("data"));
    localStorage.setItem("data", JSON.stringify({ ...stored, ...apiData }));
    localStorage.setItem("username", value.applicantName);
    window.location.href = "/chooseproduct";
  };

  const dateChange = (_, dateString) => {
    errors.dob = false;
    setValue("dob", dateString);
  };

  useEffect(() => {
    if (width <= 768) {
      setMobScreen(true);
    } else {
      setMobScreen(false);
    }
  }, [isMobScreen, width]);

  return (
    <div className="main-wrapper">
      {contextHolder}
      <div className="row mobile-view">
        {!isMobScreen && (
          <div className="col-md-7 d-md-flex d-none leftDivOTP">
            <Carousels
              CarouselList={SignUpCarousel}
              ClassProps="slik-slider-signup "
            />
          </div>
        )}
        <div className="rightDivOTP col-lg-offset-1 col-md-4">
          <div className="p-3 w-md-100 tre-register-block text-start">
            <h2>Share more details about you</h2>

            <form
              id="personaDetailsForm"
              onSubmit={handleSubmit(checkMailAvailability)}
            >
              <div className={`form-group col-md-12`}>
                <label htmlFor="applicantName" className="text-start font-14 mb-1">
                  Name of the applicant (as per PAN)
                </label>
                <div className="input-group pb-2 position-relative">
                  <span className="fa-regular fa-user tre_control-feedback"></span>
                  <input
                    type="text"
                    autoComplete="off"
                    className={`form-control${
                      errors.applicantName ? " is-invalid" : ""
                    }`}
                    id="applicantName"
                    placeholder="Enter your name as per PAN"
                    {...register("applicantName", {
                      required: true,
                    })}
                  />
                  <div className="invalid-feedback">Name is required</div>
                </div>
                <label htmlFor="email" className="text-start font-14 mb-1">
                  Email
                </label>
                <div className="input-group pb-2 position-relative">
                  <span className="fa-regular fa-envelope tre_control-feedback"></span>
                  <input
                    type="email"
                    autoComplete="off"
                    className={`form-control${
                      errors.email ? " is-invalid" : ""
                    }`}
                    id="email"
                    aria-describedby="emailHelp"
                    placeholder="Enter your Email"
                    {...register("email", {
                      required: true,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "invalid email address",
                      },
                    })}
                  />
                  <div className="invalid-feedback">Email is required</div>
                </div>

                <label htmlFor="dob" className="text-start font-14 mb-1">
                  Date of birth
                </label>
                <div className="input-group pb-2 position-relative">
                  <span className="fa-regular fa-calendar tre_control-feedback"></span>
                  <Controller
                    name="dob"
                    control={control}
                    errors={errors}
                    rules={{ required: true }}
                    render={(props) => (
                      <DatePicker
                        inputReadOnly
                        type="text"
                        disabledDate={(current) => {
                          const startDate = moment().subtract(18, "years");
                          return startDate && current.valueOf() > startDate;
                        }}
                        defaultPickerValue={dayjs(
                          get18YearBackDate(),
                          "YYYY-MM-DD"
                        )}
                        className={`form-control tre_dobdate
                        ${errors.dob ? " is-invalid" : ""}`}
                        onChange={dateChange}
                        {...props}
                      />
                    )}
                  />

                  <div className="invalid-feedback text-start font-14 mb-1">
                    Date of birth is required
                  </div>
                </div>
              </div>
              <label htmlFor="referralCode" className="text-start font-14 mb-1">
                Referral Code (Optional)
              </label>
              <div className="input-group pb-2 position-relative">
                <span className="fa-regular fa-user tre_control-feedback"></span>
                <input
                  type="text"
                  className={`form-control`}
                  id="referralCode"
                  aria-describedby="referralCode"
                  placeholder="Enter Referral Code"
                  disabled={isReferralLocked}
                  {...register("referralCode", {})}
                />
              </div>
            </form>
            <button
              className="normal-button w-100"
              type="submit"
              form="personaDetailsForm"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
